module.exports = __webpack_public_path__ + "static/HT-Digital-Hub-Chemistry-Health-Logo-7f6fe6b07efc866ed2413f8545f50e11.webp";